import {FormEvent, useEffect, useId, useRef, useState} from "react";
import {cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {FieldMessage, FieldWrapper, Input} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    RESERVATION_NAME_INPUT_LABEL,
    RESERVATION_NAME_STEP_DESCRIPTION,
    RESERVATION_NAME_STEP_TITLE,
    RESERVATION_NAME_SUBMIT_BUTTON_TEXT
} from "../constants/reservation_copy";
import {IReservationNameForm} from "../types/IReservationNameForm";
import {reservationStepContentStyle, reservationStepTextStyle} from "./reservation_step_styles";

interface IProps {
    titleId: string;
    descriptionId: string;
    nameForm: IReservationNameForm;
    className?: string;
}

// Header and close control belong to the host modal - the content renders its own paddings only
export const ReservationNameStepContent = (props: IProps) => {
    const {titleId, descriptionId, nameForm, className} = props;
    const {initialName, isSaving, errorMessage, onSubmit} = nameForm;

    const inputId = useId();
    const errorId = useId();
    const inputRef = useRef<HTMLInputElement>(null);
    const [name, setName] = useState(initialName);
    // a submit rejected with the same message as the previous one still has to bring the focus back
    const [submitCount, setSubmitCount] = useState(0);

    useEffect(() => {
        inputRef.current?.focus({preventScroll: true});
    }, []);

    useEffect(() => {
        if (errorMessage !== null && !isSaving) {
            inputRef.current?.focus({preventScroll: true});
        }
    }, [errorMessage, isSaving, submitCount]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (isSaving) {
            return;
        }

        setSubmitCount((count) => count + 1);
        onSubmit(name);
    };

    const fieldState = errorMessage ? "error" : "default";

    return (
        <form
            noValidate
            className={cx(reservationStepContentStyle, className)}
            aria-busy={isSaving}
            onSubmit={handleSubmit}
            data-testid={RP_RESERVATION_TEST_IDS.NAME_STEP}
        >
            <div className={reservationStepTextStyle}>
                <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                    {RESERVATION_NAME_STEP_TITLE}
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-gray-800)">
                    {RESERVATION_NAME_STEP_DESCRIPTION}
                </Text>
            </div>

            {/* the parts of the design system field, so that its error message can be referenced by the input */}
            <FieldWrapper
                labelContent={RESERVATION_NAME_INPUT_LABEL}
                htmlFor={inputId}
                afterChildren={
                    errorMessage ? (
                        <div role="alert" id={errorId} data-testid={RP_RESERVATION_TEST_IDS.NAME_ERROR}>
                            <FieldMessage fieldState="error">{errorMessage}</FieldMessage>
                        </div>
                    ) : null
                }
            >
                <Input
                    id={inputId}
                    name="name"
                    type="text"
                    autoComplete="name"
                    value={name}
                    // kept focusable while saving, so a rejected save can be corrected right away
                    readOnly={isSaving}
                    fieldState={fieldState}
                    aria-invalid={errorMessage ? true : undefined}
                    aria-describedby={errorMessage ? errorId : undefined}
                    inputForwardedRef={inputRef}
                    onChange={(event) => setName(event.target.value)}
                    dataTestId={RP_RESERVATION_TEST_IDS.NAME_INPUT}
                />
            </FieldWrapper>

            <Button type="submit" variant="filled_primary" size="medium" fullWidth isLoading={isSaving} dataTestId={RP_RESERVATION_TEST_IDS.NAME_SUBMIT_BUTTON}>
                {RESERVATION_NAME_SUBMIT_BUTTON_TEXT}
            </Button>
        </form>
    );
};
import {FormEvent, useEffect, useId, useRef, useState} from "react";
import {cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {FieldMessage, FieldWrapper, Input} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    RESERVATION_NAME_INPUT_LABEL,
    RESERVATION_NAME_STEP_DESCRIPTION,
    RESERVATION_NAME_STEP_TITLE,
    RESERVATION_NAME_SUBMIT_BUTTON_TEXT
} from "../constants/reservation_copy";
import {IReservationNameForm} from "../types/IReservationNameForm";
import {reservationStepContentStyle, reservationStepTextStyle} from "./reservation_step_styles";

interface IProps {
    titleId: string;
    descriptionId: string;
    nameForm: IReservationNameForm;
    className?: string;
}

// Header and close control belong to the host modal - the content renders its own paddings only
export const ReservationNameStepContent = (props: IProps) => {
    const {titleId, descriptionId, nameForm, className} = props;
    const {initialName, isSaving, errorMessage, onSubmit} = nameForm;

    const inputId = useId();
    const errorId = useId();
    const inputRef = useRef<HTMLInputElement>(null);
    const [name, setName] = useState(initialName);
    // a submit rejected with the same message as the previous one still has to bring the focus back
    const [submitCount, setSubmitCount] = useState(0);

    useEffect(() => {
        inputRef.current?.focus({preventScroll: true});
    }, []);

    useEffect(() => {
        if (errorMessage !== null && !isSaving) {
            inputRef.current?.focus({preventScroll: true});
        }
    }, [errorMessage, isSaving, submitCount]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (isSaving) {
            return;
        }

        setSubmitCount((count) => count + 1);
        onSubmit(name);
    };

    const fieldState = errorMessage ? "error" : "default";

    return (
        <form
            noValidate
            className={cx(reservationStepContentStyle, className)}
            aria-busy={isSaving}
            onSubmit={handleSubmit}
            data-testid={RP_RESERVATION_TEST_IDS.NAME_STEP}
        >
            <div className={reservationStepTextStyle}>
                <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                    {RESERVATION_NAME_STEP_TITLE}
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-gray-800)">
                    {RESERVATION_NAME_STEP_DESCRIPTION}
                </Text>
            </div>

            {/* the parts of the design system field, so that its error message can be referenced by the input */}
            <FieldWrapper
                labelContent={RESERVATION_NAME_INPUT_LABEL}
                htmlFor={inputId}
                afterChildren={
                    errorMessage ? (
                        <div role="alert" id={errorId} data-testid={RP_RESERVATION_TEST_IDS.NAME_ERROR}>
                            <FieldMessage fieldState="error">{errorMessage}</FieldMessage>
                        </div>
                    ) : null
                }
            >
                <Input
                    id={inputId}
                    name="name"
                    type="text"
                    autoComplete="name"
                    value={name}
                    // kept focusable while saving, so a rejected save can be corrected right away
                    readOnly={isSaving}
                    fieldState={fieldState}
                    aria-invalid={errorMessage ? true : undefined}
                    aria-describedby={errorMessage ? errorId : undefined}
                    inputForwardedRef={inputRef}
                    onChange={(event) => setName(event.target.value)}
                    dataTestId={RP_RESERVATION_TEST_IDS.NAME_INPUT}
                />
            </FieldWrapper>

            <Button type="submit" variant="filled_primary" size="medium" fullWidth isLoading={isSaving} dataTestId={RP_RESERVATION_TEST_IDS.NAME_SUBMIT_BUTTON}>
                {RESERVATION_NAME_SUBMIT_BUTTON_TEXT}
            </Button>
        </form>
    );
};
